/**
 * Local friends list for table left rail (username + optional wallet hint).
 * Server play Send still uses username lookup; this is UI pin list only.
 */

const KEY = "budb_friends_v1";

export type FriendEntry = {
  username: string;
  walletHint?: string;
  addedAt: number;
};

export function listFriends(): FriendEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw) as FriendEntry[];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function addFriend(username: string, walletHint?: string): FriendEntry[] {
  const u = username.trim().replace(/^@+/, "").slice(0, 32);
  if (u.length < 2) return listFriends();
  const list = listFriends().filter(
    (f) => f.username.toLowerCase() !== u.toLowerCase(),
  );
  list.unshift({
    username: u,
    walletHint,
    addedAt: Date.now(),
  });
  const out = list.slice(0, 40);
  localStorage.setItem(KEY, JSON.stringify(out));
  return out;
}

export function removeFriend(username: string): FriendEntry[] {
  const out = listFriends().filter(
    (f) => f.username.toLowerCase() !== username.toLowerCase(),
  );
  localStorage.setItem(KEY, JSON.stringify(out));
  return out;
}
